/**
 * Barbados dollar.
 */
export var BBD = {
  code: 'BBD',
  base: 10,
  exponent: 2
};